import "./NavCard.scss";

export default {
  root: "im-nav-card",
  withBorder: "im-nav-card--with-border",
  default: "im-nav-card--default",
  title: "im-nav-card__title",
  candidate: "im-nav-card--candidate",
  establishment: "im-nav-card--establishment",
  agency: "im-nav-card--agency",
  link: "im-nav-card__link",
  overtitle: "im-nav-card__overtitle",
  icon: "im-nav-card__icon",
};
